export const Path = {
    Report: '/report',

    StatisticReport: '/statistic-report',
    InvoiceReport: '/invoice-report',
    UserManagementReport: '/user-management-report',
    UserAuditTrailReport: '/user-audit-trail-report',
    MasterViewReport: '/master-view-report',
    DocumentAuditTrailReport: '/document-audit-trail-report',
    MassUpdateLog: '/mass-update-log'
}

export const REPORT_PUSHER_CHANNEL = 'scan-pusher-channel'